<script setup lang="ts">
import MessageListSkeletonItem from './message-list-skeleton-item.vue'

const { variant = 'regular' } = defineProps<{ variant?: 'regular' | 'compact' }>()

const range = Array(10).fill(0)
</script>

<template>
  <ul :class="$style.root">
    <MessageListSkeletonItem v-for="(_, index) in range" :key="index" :variant="variant" />
  </ul>
</template>

<style lang="scss" module>
.root {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex-grow: 1;
  overflow: hidden;
  justify-content: flex-end;
  padding: 0;
  margin: 0;
  height: 100%;
}
</style>
